import { useState } from 'react';

interface Props {
  orderId: string;
  onClose: () => void;
  onConfirm: (orderId: string, trackingNo: string) => void;
}

const carriers = [
  { id: 'SF', label: '顺丰速运', prefix: 'SF' },
  { id: 'YT', label: '圆通速递', prefix: 'YT' },
  { id: 'ZTO', label: '中通快递', prefix: 'ZTO' },
  { id: 'JD', label: '京东物流', prefix: 'JD' },
  { id: 'YD', label: '韵达快递', prefix: 'YD' },
  { id: 'EMS', label: 'EMS邮政', prefix: 'EMS' },
];

export default function ShipOrderModal({ orderId, onClose, onConfirm }: Props) {
  const [carrier, setCarrier] = useState('SF');
  const [trackingNo, setTrackingNo] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!trackingNo.trim()) {
      setError('请输入快递单号');
      return;
    }
    onConfirm(orderId, trackingNo.trim());
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-sm p-6">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-black text-gray-900">填写快递信息</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
            <i className="ri-close-line text-gray-500"></i>
          </button>
        </div>

        <div className="bg-gray-50 rounded-xl p-3 mb-5">
          <p className="text-xs text-gray-400">订单号</p>
          <p className="text-sm font-mono font-semibold text-gray-800 mt-0.5">{orderId}</p>
        </div>

        <div className="mb-4">
          <label className="text-xs font-semibold text-gray-600 mb-2 block">选择快递公司</label>
          <div className="grid grid-cols-3 gap-2">
            {carriers.map(c => (
              <button
                key={c.id}
                onClick={() => setCarrier(c.id)}
                className={`py-2 px-2 rounded-xl border-2 text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  carrier === c.id ? 'border-red-500 bg-red-50 text-red-700' : 'border-gray-200 text-gray-600 hover:border-gray-300'
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-5">
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">快递单号 *</label>
          <div className={`flex items-center border-2 rounded-xl px-4 py-3 gap-2 transition-colors ${error ? 'border-red-400' : 'border-gray-200 focus-within:border-red-400'}`}>
            <i className="ri-truck-line text-gray-400 text-sm"></i>
            <input
              type="text"
              value={trackingNo}
              onChange={e => { setTrackingNo(e.target.value); setError(''); }}
              placeholder={`请输入${carriers.find(c => c.id === carrier)?.label}单号`}
              className="flex-1 outline-none text-sm"
            />
          </div>
          {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-200 text-gray-600 font-semibold rounded-full cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap text-sm"
          >
            取消
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 py-3 bg-red-600 text-white font-bold rounded-full cursor-pointer hover:bg-red-700 transition-colors whitespace-nowrap text-sm"
          >
            确认发货
          </button>
        </div>
      </div>
    </div>
  );
}
